<markant-platform-modal-bridge>
  <markant-dialog
    class="member-edit-dialog"
    [open]="true"
    [headTitle]="
      'dashboardOverview.groupAssignment.memberEditDialog.headline'
        | transloco: { groupName }
    "
    [subTitle]="
      'dashboardOverview.groupAssignment.memberEditDialog.subHeadline'
        | transloco
    "
    (close)="closeDialog()"
  >
    <div class="member-edit-dialog-content">
      <markant-searchbar
        class="search-input"
        data-cy="table-searchbar"
        [placeholder]="
          'dashboardOverview.groupAssignment.memberEditDialog.searchPlaceholder'
            | transloco
        "
        [debounce]="300"
        (valueChange)="onSearchChange($event.detail)"
      >
      </markant-searchbar>

      <div class="table-section">
        <div class="table-container">
          <div class="table-title-line">
            <h5 class="table-title">
              {{
                'dashboardOverview.groupAssignment.memberEditDialog.employeeList'
                  | transloco
              }}
            </h5>
          </div>

          <markant-platform-table
            #employeesListTable
            class="left-table"
            [data]="employeesListTableData"
            [stickyHeader]="true"
            [defaultHeaderCells]="employeesListTableDraft.headerAndTableCells"
            [loading]="employeesListTableIsLoading"
            [totalCount]="totalCount"
            [pageSize]="pageSize"
            [pageIndex]="pageIndex"
            [preselected]="preselectedValue"
            [resetSelection]="(resetSelection$ | async) || false"
            (indexChanged)="onIndexChange($event)"
            (pageSizeChanged)="onPageSizeChange($event)"
            (sortChanged)="onSortChange($event)"
            (selectionChanged)="onToggleAction($event)"
          >
          </markant-platform-table>
        </div>

        <markant-seperator
          class="separator"
          orientation="vertical"
        ></markant-seperator>

        <div class="table-container" data-cy="employee-table">
          <div class="table-title-line">
            <h5 class="table-title">
              {{
                'dashboardOverview.groupAssignment.memberEditDialog.assignedEmployees'
                  | transloco
              }}
            </h5>
            <markant-button
              class="delete-all-button"
              colorScheme="primary"
              variant="clear"
              [disabled]="!selectedEmployees.length"
              (click)="deleteAll()"
              (keydown.enter)="deleteAll()"
            >
              <markant-icon
                icon="m_close-small"
                slot="icon-leading"
              ></markant-icon>
              {{
                'dashboardOverview.groupAssignment.memberEditDialog.removeAll'
                  | transloco
              }}
            </markant-button>
          </div>

          @if (selectedEmployees.length) {
            <markant-platform-table
              class="right-table"
              [stickyHeader]="true"
              [data]="assignedEmployeesTableData"
              [defaultHeaderCells]="
                assignedEmployeesTableDraft.headerAndTableCells
              "
              [showPagination]="false"
              (sortChanged)="assignedEmployeesOnSortChange($event)"
            >
            </markant-platform-table>
          } @else {
            <div class="no-employees-content">
              <h5>
                {{
                  'dashboardOverview.groupAssignment.memberEditDialog.addEmployees'
                    | transloco
                }}
              </h5>
            </div>
          }
        </div>
      </div>
    </div>

    <div slot="markant-dialog-footer">
      <markant-button
        colorScheme="primary"
        variant="clear"
        data-markant-dialog-action="cancel"
      >
        {{ 'common.cancel' | transloco }}
      </markant-button>

      <markant-button
        data-cy="update-members-button"
        (click)="updateMembers()"
        (keydown.enter)="updateMembers()"
      >
        {{
          'dashboardOverview.groupAssignment.memberEditDialog.confirmButton'
            | transloco
        }}
      </markant-button>
    </div>
  </markant-dialog>
</markant-platform-modal-bridge>
